<ng-container *ngIf="!loading; else spinner">
  <div class="row mx-0">
    <div class="col-4 px-0 text-start">
      <h3>{{ client.humanizedName }}</h3>
    </div>
    <div *ngIf="clientConfigurationOptions.length > 0" class="col-8 px-0 text-end">
      <a routerLink="/capture-admin/client-management/clients/{{client.id}}/options-change-log">
        <span>Change Log</span>
      </a>
    </div>
  </div>
  <div class="row">
    <h5 class="mt-3 mb-0">Configuration Values</h5>
    <div class="configuration-values px-1 mt-3" *ngIf="clientConfigurationOptions.length > 0; else noConfigOptions">
      <table class="table table-borderless">
        <tbody>
          <tr *ngFor="let config of clientConfigurationOptions">
            <td>{{ config.title }}</td>
            <td>{{ config.value | json }}</td>
            <td>
              <a routerLink="/capture-admin/change-log/ClientConfigurationOption/{{ config.id }}">
                <span>Change Log</span>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>
<ng-template #noConfigOptions>
  <p class="mt-3">There are no configuration options for this client.</p>
</ng-template>
<ng-template #spinner>
  <mat-spinner />
</ng-template>
